import { saasServiceName } from '../constants.js'

function _notifyComplete ({ bus, chatStore }) {
  bus.on('transmissionManager-messagecomplete', chatStore.messageTransmissionComplete)
  bus.on('chatstore-resyncnow', chatStore.resyncNow)
  bus.emit('RJMRefreshAllStoresCompleted')
}

function refreshAllStores ({ bus, Notify, userManagementClientStore, userDetailsStore, router, tenantName, chatStore, matrix }) {
  const callback1 = {
    ok: async function (response) {
      await setupChatStore({
        userManagementClientStore,
        chatStore,
        router,
        tenantName,
        matrix,
        bus,
        Notify,
        userDetailsStore
      })
    },
    error: function (response) {
      if (typeof (Notify) !== 'undefined') {
        Notify.create({
          color: 'negative',
          message: 'ERROR when loading user data!'
        })
      }
      console.log('ERROR when loading user data', response)
    }
  }
  if (userManagementClientStore.isLoggedIn) {
    console.log('RJMDEBUG001 common.js userManagementClientStore is logged in')
    userDetailsStore.refresh({
      force: false,
      router,
      tenantName,
      callback: callback1
    })
  } else {
    _notifyComplete({
      bus,
      chatStore
    })
  }
}

async function setupChatStore ({ userManagementClientStore, chatStore, router, tenantName, matrix, bus, Notify, userDetailsStore }) {
  const endpoints = userManagementClientStore.endpointInfo
  await chatStore.init_chat_store({
    router,
    tenantName,
    serverInfo: endpoints[saasServiceName].serverInfo,
    matrix,
    userDetailsStore
  })

  // Called when the user details store refresh is complete as part of the refresh_all_stores
  const callback = {
    ok: function (response) {
      _notifyComplete({
        bus,
        chatStore
      })
    },
    error: function (response) {
      if (typeof (Notify) !== 'undefined') {
        Notify.create({
          color: 'negative',
          message: 'ERROR when connecting to chat stroe!'
        })
      }
      console.log('ERROR when connecting to chat stroe!', response)
    }
  }
  chatStore.get_credentails_and_establish_login_session({
    tenantName,
    router,
    callback,
    userDetailsStore
  })
}

export default {
  refreshAllStores
}
